

window.Userback = window.Userback || {};
window.Userback.access_token = '660|1280|RoWgSVvNwNblWVHoZhAKGEY1FW8sEq9vP6MI1hvy4GU0BBpBS0';

(function(id) {
   if (document.getElementById(id)) {return;}
   var s = document.createElement('script');
   s.id = id;
   s.src = 'https://static.userback.io/widget/v1.js';
   var parent_node = document.head || document.body;
   parent_node.appendChild(s);
})('userback-sdk');



/** WEBPACK FOOTER **
 ** ./src/client/userback.js
 **/